import { styled } from '@mui/material/styles'
import NoWrapTableCell from '../NoWrapTableCell'

const ClickableTableCell = styled(NoWrapTableCell)(() => ({
  cursor: 'pointer',
  fontWeight: 'bold'
}))

export default ClickableTableCell
